import { ReactElement, useEffect } from 'react';

import { useRecoilState } from 'recoil';

import SidebarTabButton from './SidebarTabButton';
import { sidebarAtom, SidebarState } from '../../../utils/recoil/atoms/sidebarAtom';
import Card from '../Card';

import './SidebarTabButton.scss';
import '../Sidebar.scss';
import { useLocation } from 'react-router-dom';
import DiscussionSwitchSidebarContent from './discussion/DiscussionSwitchSidebarContent';

interface SingleTabSidebarProps {
  tabLabel: string;
  component?: ReactElement;
}

export function SingleTabSidebar({ tabLabel, component }: SingleTabSidebarProps) {
  return (
    <Card className="sidebar">
      <div className="sidebar-tab-labels-container">
        <h2 className="sidebar-tab-button inline-block ml-6 active">{tabLabel}</h2>
      </div>
      {component}
    </Card>
  );
}

interface DoubleTabSidebarProps {
  tabLabels: [string, string];
  component1?: ReactElement;
  component2?: ReactElement;
}

export function DoubleTabSidebar({ tabLabels, component1, component2 }: DoubleTabSidebarProps) {
  const [state, setState] = useRecoilState(sidebarAtom);
  const { hash } = useLocation();

  useEffect(() => {
    if (hash.includes('discussion') && component2?.type === DiscussionSwitchSidebarContent) {
      setState(SidebarState.SECOND_PAGE);
    }
  }, [hash, setState, component2?.type]);

  return (
    <Card className="sidebar">
      <div className="sidebar-tab-labels-container flex align-center justify-around">
        <SidebarTabButton
          label={tabLabels[0]}
          active={state === SidebarState.FIRST_PAGE}
          onClick={() => setState(SidebarState.FIRST_PAGE)}
        />
        <SidebarTabButton
          label={tabLabels[1]}
          active={state === SidebarState.SECOND_PAGE}
          onClick={() => setState(SidebarState.SECOND_PAGE)}
        />
      </div>
      {state === SidebarState.FIRST_PAGE && component1}
      {state === SidebarState.SECOND_PAGE && component2}
    </Card>
  );
}
